import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CoreModule } from 'src/app/core/core.module';
import { HelpCenterComponent } from './help-center.component';
import { HelpCenterRoutingModule } from './help-center-routing.module';

@NgModule({
    declarations: [
        HelpCenterComponent,
    ],
    imports: [
        HelpCenterRoutingModule,
        CoreModule,
        BrowserModule,
        ButtonModule,
        CardModule,
    ],
    providers: []
})
export class HelpCenterModule { }
